import type { FC, ReactNode } from "react";
import { Flex, Icon, Text } from "@huub-web/ui";

import { containerStyle, textStyle } from "./Tip.css";

export type TipProps = {
  name?: string | null;
  cta?: ReactNode;
  children?: string;
  trailing?: ReactNode;
};

export const Tip: FC<TipProps> = ({
  name = "Tip",
  children,
  cta,
  trailing,
}) => (
  <Flex
    direction="column"
    gap="xs"
    className={containerStyle}
    align="flex-start"
  >
    <Flex gap="xs" align="flex-start" shrink={false}>
      <Icon icon="aiFilled" size="s" color="primary" />
      {name && (
        <Text variant="bodyS" bold>
          {name}
        </Text>
      )}
    </Flex>
    <Flex direction="column" gap="s">
      {children && (
        <Text className={textStyle} variant="bodyS" markdown>
          {children}
        </Text>
      )}
      {trailing}
      {cta}
    </Flex>
  </Flex>
);
